export const modal = {
  zIndex: 1,
  background: "rgb(145, 154, 150, 0.3)",
};

export const box = {
  position: "absolute",
  top: "50%",
  left: "50%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "32px",
  minWidth: "491px",
  px: "56px",
  py: "40px",
  borderRadius: "30px",
  outline: 0,
  transform: "translate(-50%, -50%)",
  background: "#FFFFFF",
};

export const boxInput = {
  display: "flex",
  alignItems: "center",
  gap: "32px",
  width: "100%",
  position: "relative",
};

export const title = {
  fontFamily: "Montserrat",
  fontStyle: "normal",
  fontWeight: "700",
  fontSize: "24px",
  textAlign: "center",
  color: "#343447",
};

export const boxSuccess = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "24px",
  width: "600px",
  height: "512px",
};
